/**
 * Check if the app is at a portal endpoint
 */
export const isPortal = () => {
	// todo: yarn watch:portal does not have /portals
	return window.location.pathname.match(/^\/portals\//) != null;
};

export default isPortal;
